export const DAYS = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"];

export const MONTHS_ID = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export function rupiah(n) {
  const num = Number(n || 0);
  return "Rp " + num.toLocaleString("id-ID");
}

export function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function monthLabel(m) {
  if (!m) return "-";
  const [y, mo] = m.split("-").map(Number);
  return `${MONTHS_ID[mo - 1]} ${y}`;
}

export function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function dateLabel(s) {
  if (!s) return "-";
  const d = new Date(s);
  if (isNaN(d)) return s;
  return `${d.getDate()} ${MONTHS_ID[d.getMonth()]} ${d.getFullYear()}`;
}

export function waLink(phone, text) {
  let p = String(phone || "").replace(/[^0-9]/g, "");
  if (p.startsWith("0")) p = "62" + p.slice(1);
  return `https://wa.me/${p}?text=${encodeURIComponent(text || "")}`;
}

export const PAYMENT_STATUS = {
  lunas: { label: "Lunas", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  sebagian: { label: "Sebagian", cls: "bg-amber-100 text-amber-700 border-amber-300" },
  terlambat: { label: "Terlambat", cls: "bg-rose-100 text-rose-700 border-rose-300" },
  belum_bayar: { label: "Belum Bayar", cls: "bg-slate-100 text-slate-600 border-slate-300" },
};

export const ATTEND_STATUS = {
  hadir: { label: "Hadir", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  izin: { label: "Izin", cls: "bg-sky-100 text-sky-700 border-sky-300" },
  sakit: { label: "Sakit", cls: "bg-amber-100 text-amber-700 border-amber-300" },
  alpa: { label: "Alpa", cls: "bg-rose-100 text-rose-700 border-rose-300" },
  lainnya: { label: "Alasan Lain", cls: "bg-slate-100 text-slate-600 border-slate-300" },
};

export const UNDERSTANDING = {
  paham: { label: "Paham", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  cukup: { label: "Cukup Paham", cls: "bg-amber-100 text-amber-700 border-amber-300" },
  ulang: { label: "Perlu Diulang", cls: "bg-rose-100 text-rose-700 border-rose-300" },
};

export const SESSION_STATUS = {
  belum: { label: "Belum ada tindak lanjut", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  hadir: { label: "Hadir", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  tidak_hadir: { label: "Tidak Hadir", cls: "bg-rose-100 text-rose-700 border-rose-300" },
  pengganti: { label: "Pengganti", cls: "bg-violet-100 text-violet-700 border-violet-300" },
  pengganti_hadir: { label: "Hadir (Pengganti)", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  tidak_diikuti: { label: "Tidak Diikuti", cls: "bg-slate-200 text-slate-600 border-slate-300" },
};

export function ageLabel(birth) {
  if (!birth) return "";
  const b = new Date(birth);
  if (isNaN(b)) return "";
  const now = new Date();
  let y = now.getFullYear() - b.getFullYear();
  let m = now.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < b.getDate())) { y--; m += 12; }
  if (now.getDate() < b.getDate()) m--;
  if (m < 0) m += 12;
  return y > 0 ? `${y} thn${m > 0 ? ` ${m} bln` : ""}` : `${m} bln`;
}

export function mondayOf(d = new Date()) {
  const x = new Date(d); const day = (x.getDay() + 6) % 7; x.setDate(x.getDate() - day);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`;
}

export function shortDate(s) {
  const d = new Date(s);
  return `${d.getDate()} ${MONTHS_ID[d.getMonth()].slice(0, 3)} ${d.getFullYear()}`;
}

export const LEVEL_META = {
  TPA: { cls: "bg-violet-100 text-violet-700 border-violet-300" },
  TK: { cls: "bg-sky-100 text-sky-700 border-sky-300" },
  SD: { cls: "bg-orange-100 text-orange-700 border-orange-300" },
};
